import { render, staticRenderFns } from "./cusPage.vue?vue&type=template&id=567aa9bc&scoped=true&"
import script from "./cusPage.vue?vue&type=script&lang=js&"
export * from "./cusPage.vue?vue&type=script&lang=js&"
import style0 from "./cusPage.vue?vue&type=style&index=0&id=567aa9bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567aa9bc",
  null
  
)

export default component.exports